import React, { useCallback, useState, useEffect } from "react";
import { Row, Col, Button, InputGroup, Input } from "reactstrap";

import { debounce } from "../../../../utils/Helper";
import style from "./Toolbar.module.scss";

const Toolbar = ({ filters: rootFilter, setFilters: rootOnChange, discrepantCount, actions, loading }) => {
  const filters = rootFilter;
  const setFilters = rootOnChange;
  const debounceCallback = useCallback(
    debounce((nextValues) => rootOnChange(nextValues), 200),
    []
  );
  const options = ["All", "Matched", "Discrepant", "Pending Sett"];
  const [funds, setFunds] = useState([]);

  const changeFilterValue = (fieldName, fieldValue) => {
    const nextFilters = {
      ...filters,
      [fieldName]: fieldValue,
    };
    debounceCallback(nextFilters);
    setFilters(nextFilters);
  };

  const onSearch = () => {
    actions.serverSearch();
  };

  useEffect(() => {
    actions.fetchFunds().then((f) => {
      setFunds(f.funds);
      if (f && f.funds && f.funds.length > 0) {
        setFilters((prev) => ({
          ...prev,
          AssetTicker: f.funds[0].Value,
        }));
      }
    });
  }, []);

  return (
    <div className={style.toolbar}>
      <Row>
        <Col>
          <h6 className={"h6 page-title " + style.totals}>Funds Share</h6>
          <div className="text-muted page-desc">Consolidation Report</div>
        </Col>
        <Col md={0} lg={2} xl={2}>
          <InputGroup>
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className="fa fa-search"></i>
              </span>
            </div>

            <Input
              type="text"
              placeholder="Search something"
              value={filters.text || ""}
              onChange={(e) => changeFilterValue("text", e.target.value)}
            />
          </InputGroup>
        </Col>
        <Col>
          <Input
            type="select"
            value={filters.AssetTicker || ""}
            onChange={(e) => changeFilterValue("AssetTicker", e.target.value)}
          >
            <option value="" disabled hidden>
              Funds...
            </option>
            {funds.map((s) => (
              <option key={s.Id} value={s.Value}>
                {s.Value}
              </option>
            ))}
          </Input>
        </Col>
        <Col className="d-flex">
          <Input
            type="date"
            value={filters.toDate}
            placeholder="To"
            onChange={(e) => changeFilterValue("toDate", e.target.value)}
          />
        </Col>
        <Button
          type="button"
          color="primary"
          style={{
            height: "35px",
          }}
          onClick={() => onSearch()}
          disabled={loading}
        >
          Search
        </Button>
        <Col>
          <div className={style.toggle}>
            {options.map((option) => (
              <button
                key={option}
                type="button"
                className={`${style.option} ${filters.summaryFilter === option ? style.active : ""}`}
                onClick={() => changeFilterValue("summaryFilter", option)}
              >
                {option}
                {option === "Discrepant" && discrepantCount > 0 && (
                  <span className={style.badge}>{discrepantCount}</span>
                )}
              </button>
            ))}
          </div>
        </Col>
        <Col className={style.export}>
          <Button color="primary" onClick={() => actions.downloadReport()}>
            <i className="fa fa-download"></i>
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default Toolbar;
